export const sizeList = [
  {
    value: 4,
    label: '4',
  },
  {
    value: 4.5,
    label: '4.5',
  },
  {
    value: 5,
    label: '5',
  },
  {
    value: 5.5,
    label: '5.5',
  },
  {
    value: 6,
    label: '6',
  },
  {
    value: 6.5,
    label: '6.5',
  },
  {
    value: 7,
    label: '7',
  },
  {
    value: 7.5,
    label: '7.5',
  },
  {
    value: 8,
    label: '8',
  },
  {
    value: 8.5,
    label: '8.5',
  },
  {
    value: 9,
    label: '9',
  },
  {
    value: 9.5,
    label: '9.5',
  },
  {
    value: 10,
    label: '10',
  },
  {
    value: 10.5,
    label: '10.5',
  },
  {
    value: 11,
    label: '11',
  },
  {
    value: 11.5,
    label: '11.5',
  },
  {
    value: 12,
    label: '12',
  },
  {
    value: 12.5,
    label: '12.5',
  },
  {
    value: 13,
    label: '13',
  },
];
